//@flow
//Action Type Registered
export const HARMONIA_INV_SUBMIT_SUCCESS='HARMONIA_INV_SUBMIT_SUCCESS'
export const HARMONIA_INV_SUBMIT_ERROR='HARMONIA_INV_SUBMIT_ERROR'
export const HARMONIA_INV_SUBMITTED_COMPLETED='HARMONIA_INV_SUBMITTED_COMPLETED'
export const HARMONIA_EDIT_VERIFY_FORM_DATA_SUCCESS='HARMONIA_EDIT_VERIFY_FORM_DATA_SUCCESS'
export const HARMONIA_EDIT_VERIFY_FORM_DATA_ERROR='HARMONIA_EDIT_VERIFY_FORM_DATA_ERROR'
export const HARMONIA_UPDATE_FORM_ERROR='HARMONIA_UPDATE_FORM_ERROR'
export const REFRESH_HARMONIA_VENDORS_SUCCESS='REFRESH_HARMONIA_VENDORS_SUCCESS'
export const REFRESH_HARMONIA_VENDORS_ERROR='REFRESH_HARMONIA_VENDORS_ERROR'
export const GET_HARMONIA_ITEMS_SUCCESS='GET_HARMONIA_ITEMS_SUCCESS';
export const GET_HARMONIA_ITEMS_ERROR='GET_HARMONIA_ITEMS_ERROR';
export const CREATE_NEW_HARMONIA_ITEM_SUCCESS='CREATE_NEW_HARMONIA_ITEM_SUCCESS';
export const CREATE_NEW_HARMONIA_ITEM_ERROR='CREATE_NEW_HARMONIA_ITEM_ERROR';
export const EDIT_HARMONIA_ITEM='EDIT_HARMONIA_ITEM';
export const UPDATE_HARMONIA_ITEM_SUCCESS='UPDATE_HARMONIA_ITEM_SUCCESS';
export const UPDATE_HARMONIA_ITEM_ERROR='UPDATE_HARMONIA_ITEM_ERROR';
export const MOVE_DOWN_HARMONIA_ITEM_SUCCESS='MOVE_DOWN_HARMONIA_ITEM_SUCCESS';
export const MOVE_DOWN_HARMONIA_ITEM_ERROR='MOVE_DOWN_HARMONIA_ITEM_ERROR';
export const MOVE_UP_HARMONIA_ITEM_SUCCESS='MOVE_UP_HARMONIA_ITEM_SUCCESS';
export const MOVE_UP_HARMONIA_ITEM_ERROR='MOVE_UP_HARMONIA_ITEM_ERROR';
export const DELETE_HARMONIA_ITEM_SUCCESS='DELETE_HARMONIA_ITEM_SUCCESS';
export const DELETE_HARMONIA_ITEM_ERROR='DELETE_HARMONIA_ITEM_ERROR';
export const SELECTED_HARMONIA_ITEM_ID='SELECTED_HARMONIA_ITEM_ID';
export const REFRESH_HARMONIA_ITEM='REFRESH_HARMONIA_ITEM';
export const OPEN_ADD_EDIT_LINEITEM_FORM='HARMONIA_OPEN_ADD_EDIT_LINEITEM_FORM'
export const CANCEL_ADD_EDIT_LINEITEN_FORM='HARMONIA_CANCEL_ADD_EDIT_LINEITEN_FORM'


// WEBPACK FOOTER //
// ./src/redux/harmonia/actionTypes.js